import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import { ButtonForm } from '../../../components/shared/formStyles.styled';
import CheckBox from '../../../components/shared/CheckBox';
import RadioButton from '../../../components/shared/RadioButton';
import CustomTrash from '../../../components/shared/treatedIcons/CustomTrash';
import { getGarantias, updateGarantias } from '../../../services/customer/garantias';
import { extractErrorMessages } from '../../../utils/reduxUtils';

const MENSAGEM_PRODUTOS_LUCIA_OBRIGATORIOS = 'Selecione ao menos um produto que a LucIA poderá solicitar.';

const DOC_DEFAULTS = [
  { id: 'identidade', label: 'Identidade c/CPF' },
  { id: 'compr_residencia', label: 'Compr. Residência' },
  { id: 'compr_renda', label: 'Compr. Renda' },
  { id: 'matricula_rgi', label: 'Matrícula/RGI do Imóvel' },
  { id: 'certidao_casamento', label: 'Certidão de Casamento' },
];

class ClientGarantias extends PureComponent {
  state = {
    garantiasFc: [],
    documentosDisponiveis: DOC_DEFAULTS,
    customizadas: [],
    customDraftNome: '',
    coletaEAnalisa: null,
    maxCustomizadas: 2,
    savingGarantias: false,
    loading: true,
    produtosLucia: [],
    luciaColetaAtivada: true,
    luciaSolicitaAtivada: false,
    showInactiveGarantias: false,
  };

  componentDidMount() {
    this.loadGarantias();
  }

  getToken = () => {
    const login = this.props.login;
    if (!login || !login.user || !login.user.token) return undefined;
    return login.user.token.access_token;
  };

  mapFromApi = (data) => {
    const docsDisp = data.documentos_disponiveis || DOC_DEFAULTS;
    const ativasMap = {};
    (data.ativas || []).forEach((item) => {
      ativasMap[item.nome] = item;
    });

    const garantiasFc = (data.fc_disponiveis || []).map((nome) => {
      const ativa = ativasMap[nome];
      return {
        nome,
        checked: Boolean(ativa),
        modo: (ativa && ativa.modo) || 'SEMPRE',
        documentos: (ativa && ativa.documentos) || [],
        documentos_fiador: (ativa && ativa.documentos_fiador) || [],
      };
    });

    const customizadas = (data.garantias_customizadas || []).map((c) => ({
      nome: c.nome,
      modo: c.modo || 'SEMPRE',
      documentos: c.documentos || [],
    }));

    const produtosLucia = (data.produtos_lucia || []).map((p) => ({
      id: Number(p.id),
      titulo: p.titulo || String(p.id),
      checked: Boolean(p.checked),
    }));

    return {
      garantiasFc,
      documentosDisponiveis: docsDisp,
      customizadas,
      coletaEAnalisa: data.coleta_e_analisa === null || data.coleta_e_analisa === undefined
        ? null
        : Boolean(data.coleta_e_analisa),
      maxCustomizadas: data.max_customizadas || 2,
      customDraftNome: '',
      produtosLucia,
      luciaColetaAtivada: data.lucia_coleta_ativada !== false && data.lucia_coleta_ativada !== 0,
      luciaSolicitaAtivada: data.lucia_solicita_ativada === true,
    };
  };

  buildPayload = (state = this.state) => ({
    garantias: state.garantiasFc
      .filter((g) => g.checked)
      .map((g) => ({
        nome: g.nome,
        modo: g.modo || 'SEMPRE',
        documentos: g.documentos || [],
        documentos_fiador: g.nome === 'FIADOR' ? g.documentos_fiador || [] : [],
      })),
    garantias_customizadas: (state.customizadas || []).map((c) => ({
      nome: c.nome,
      modo: c.modo || 'SEMPRE',
      documentos: c.documentos || [],
    })),
    coleta_e_analisa: state.coletaEAnalisa === null ? null : Boolean(state.coletaEAnalisa),
    produtos_lucia: (state.produtosLucia || [])
      .filter((p) => p.checked)
      .map((p) => Number(p.id)),
  });

  loadGarantias = async () => {
    const token = this.getToken();
    if (!token) {
      this.setState({ loading: false });
      return;
    }
    this.setState({ loading: true });
    try {
      const result = await getGarantias(token);
      if (result.status >= 400) {
        toastr.error('Garantias', 'Não foi possível carregar as garantias.');
        this.setState({ loading: false });
        return;
      }
      const data = (result.data && result.data.data) || {};
      this.setState({ ...this.mapFromApi(data), loading: false });
    } catch (err) {
      toastr.error('Garantias', 'Não foi possível carregar as garantias.');
      this.setState({ loading: false });
    }
  };

  persist = async (nextState) => {
    if (!this.props.canEdit) return;
    const token = this.getToken();
    if (!token) return;

    this.setState({ savingGarantias: true, ...nextState });
    try {
      const merged = { ...this.state, ...nextState };
      const result = await updateGarantias(token, this.buildPayload(merged));
      if (result.status === 403) {
        toastr.error('Garantias', 'Apenas o usuário MASTER pode alterar essas configurações.');
        await this.loadGarantias();
        return;
      }
      if (result.status >= 400) {
        const msg = extractErrorMessages(result.data && result.data.message) || 'Não foi possível salvar as garantias.';
        toastr.error('Garantias', msg);
        await this.loadGarantias();
        return;
      }
      const data = (result.data && result.data.data) || {};
      this.setState(this.mapFromApi(data));
      toastr.success('Garantias', result.data.message || 'Garantias atualizadas.');
    } catch (err) {
      toastr.error('Garantias', 'Não foi possível salvar as garantias.');
      await this.loadGarantias();
    } finally {
      this.setState({ savingGarantias: false });
    }
  };

  toggleProdutoLucia = (productId) => {
    if (!this.props.canEdit) return;
    const atual = this.state.produtosLucia.find((p) => Number(p.id) === Number(productId));
    const marcados = this.state.produtosLucia.filter((p) => p.checked).length;
    if (this.state.luciaSolicitaAtivada && atual && atual.checked && marcados === 1) {
      toastr.warning('Configurações LucIA', MENSAGEM_PRODUTOS_LUCIA_OBRIGATORIOS);
      return;
    }
    const produtosLucia = this.state.produtosLucia.map((p) =>
      Number(p.id) === Number(productId) ? { ...p, checked: !p.checked } : p
    );
    this.persist({ produtosLucia });
  };

  toggleGarantia = (nome) => {
    if (!this.props.canEdit) return;
    const allDocs = this.state.documentosDisponiveis.map((d) => d.id);
    const garantiasFc = this.state.garantiasFc.map((g) =>
      g.nome === nome
        ? {
            ...g,
            checked: !g.checked,
            documentos: g.checked ? [] : (g.documentos.length ? g.documentos : allDocs),
            documentos_fiador: g.checked
              ? []
              : (g.nome === 'FIADOR'
                  ? (g.documentos_fiador.length ? g.documentos_fiador : allDocs)
                  : g.documentos_fiador),
          }
        : g
    );
    this.persist({ garantiasFc });
  };

  setModo = (nome, modo) => {
    if (!this.props.canEdit) return;
    this.persist({
      garantiasFc: this.state.garantiasFc.map((g) => (g.nome === nome ? { ...g, modo } : g)),
    });
  };

  toggleDoc = (nome, docId, field = 'documentos') => {
    if (!this.props.canEdit) return;
    const target = this.state.garantiasFc.find((g) => g.nome === nome);
    const list = (target && target[field]) || [];
    if (list.length === 1 && list.includes(docId)) {
      toastr.warning('Garantias', 'Mantenha ao menos um documento na garantia ativa.');
      return;
    }
    const garantiasFc = this.state.garantiasFc.map((g) => {
      if (g.nome !== nome) return g;
      const nextList = list.includes(docId) ? list.filter((d) => d !== docId) : [...list, docId];
      return { ...g, [field]: nextList };
    });
    this.persist({ garantiasFc });
  };

  onColetaEAnalisaChange = (value) => {
    if (!this.props.canEdit) return;
    this.persist({ coletaEAnalisa: value });
  };

  addCustom = () => {
    if (!this.props.canEdit) return;
    const nome = (this.state.customDraftNome || '').trim().toLocaleUpperCase('pt-BR');
    if (!nome) {
      toastr.warning('Garantias', 'Informe o nome da garantia personalizada.');
      return;
    }
    if (this.state.customizadas.length >= this.state.maxCustomizadas) {
      toastr.warning('Garantias', `Máximo de ${this.state.maxCustomizadas} garantias personalizadas.`);
      return;
    }
    if (this.state.customizadas.some((c) => c.nome === nome) || this.state.garantiasFc.some((g) => g.nome === nome)) {
      toastr.warning('Garantias', 'Essa garantia já existe.');
      return;
    }
    const allDocs = this.state.documentosDisponiveis.map((d) => d.id);
    this.persist({
      customizadas: [...this.state.customizadas, { nome, modo: 'SEMPRE', documentos: allDocs }],
      customDraftNome: '',
    });
  };

  removeCustom = (nome) => {
    if (!this.props.canEdit) return;
    this.persist({ customizadas: this.state.customizadas.filter((c) => c.nome !== nome) });
  };

  setCustomModo = (nome, modo) => {
    if (!this.props.canEdit) return;
    this.persist({
      customizadas: this.state.customizadas.map((c) => (c.nome === nome ? { ...c, modo } : c)),
    });
  };

  toggleCustomDoc = (nome, docId) => {
    if (!this.props.canEdit) return;
    const target = this.state.customizadas.find((c) => c.nome === nome);
    const list = (target && target.documentos) || [];
    if (list.length === 1 && list.includes(docId)) {
      toastr.warning('Garantias', 'Mantenha ao menos um documento na garantia ativa.');
      return;
    }
    const customizadas = this.state.customizadas.map((c) => {
      if (c.nome !== nome) return c;
      const nextList = list.includes(docId) ? list.filter((d) => d !== docId) : [...list, docId];
      return { ...c, documentos: nextList };
    });
    this.persist({ customizadas });
  };

  renderDocChecks = (selected, onToggle, prefix) => {
    const { documentosDisponiveis, savingGarantias } = this.state;
    const { canEdit } = this.props;
    return (
      <div className="lucia-config-docs-grid">
        {documentosDisponiveis.map((doc) => (
          <div key={`${prefix}-${doc.id}`} className="lucia-config-doc-item">
            <CheckBox
              name={`${prefix}-${doc.id}`}
              label={doc.label}
              checked={(selected || []).includes(doc.id)}
              disabled={!canEdit || savingGarantias}
              onChange={() => onToggle(doc.id)}
              customstyle="width: 100%; white-space: normal;"
            />
          </div>
        ))}
      </div>
    );
  };

  renderGarantiaBlock = (g) => {
    const { savingGarantias } = this.state;
    const { canEdit } = this.props;
    const disabled = !canEdit || savingGarantias;
    const isFiador = g.nome === 'FIADOR';

    return (
      <div key={g.nome} className="lucia-config-garantia-block lucia-config-garantia-block--active">
        <CheckBox
          boxColor="color_green"
          name={`garantia-fc-cli-${g.nome}`}
          label={g.nome}
          checked={g.checked}
          disabled={disabled}
          onChange={() => this.toggleGarantia(g.nome)}
          labelStyles={{ fontWeight: 600 }}
          customstyle="width: 100%; white-space: normal;"
        />
        <div className="lucia-config-garantia-details">
          <div className="lucia-config-modo-row">
            <RadioButton
              id={`modo-cli-${g.nome}-sempre`}
              label="Sempre"
              checked={(g.modo || 'SEMPRE') === 'SEMPRE'}
              disabled={disabled}
              onChange={() => this.setModo(g.nome, 'SEMPRE')}
            />
            <RadioButton
              id={`modo-cli-${g.nome}-opcional`}
              label="Opcional"
              checked={g.modo === 'OPCIONAL'}
              disabled={disabled}
              onChange={() => this.setModo(g.nome, 'OPCIONAL')}
            />
          </div>
          {isFiador ? (
            <div className="lucia-config-fiador-groups">
              <div>
                <div className="lucia-config-subgroup-label">Inquilino</div>
                {this.renderDocChecks(
                  g.documentos,
                  (docId) => this.toggleDoc(g.nome, docId, 'documentos'),
                  `inq-${g.nome}`
                )}
              </div>
              <div>
                <div className="lucia-config-subgroup-label">Fiador</div>
                {this.renderDocChecks(
                  g.documentos_fiador,
                  (docId) => this.toggleDoc(g.nome, docId, 'documentos_fiador'),
                  `fia-${g.nome}`
                )}
              </div>
            </div>
          ) : (
            this.renderDocChecks(
              g.documentos,
              (docId) => this.toggleDoc(g.nome, docId, 'documentos'),
              `doc-${g.nome}`
            )
          )}
        </div>
      </div>
    );
  };

  renderInactiveGarantiaRow = (g) => {
    const { savingGarantias } = this.state;
    const { canEdit } = this.props;
    const disabled = !canEdit || savingGarantias;

    return (
      <div key={g.nome} className="lucia-config-inactive-item">
        <CheckBox
          boxColor="color_green"
          name={`garantia-fc-cli-inactive-${g.nome}`}
          label={g.nome}
          checked={false}
          disabled={disabled}
          onChange={() => this.toggleGarantia(g.nome)}
          customstyle="width: 100%; white-space: normal;"
        />
      </div>
    );
  };

  render() {
    const {
      garantiasFc,
      customizadas,
      customDraftNome,
      maxCustomizadas,
      coletaEAnalisa,
      savingGarantias,
      loading,
      produtosLucia,
      luciaColetaAtivada,
      luciaSolicitaAtivada,
      showInactiveGarantias,
    } = this.state;
    const { canEdit } = this.props;
    const disabled = !canEdit || savingGarantias || loading;
    const garantiasAtivas = garantiasFc.filter((g) => g.checked);
    const garantiasInativas = garantiasFc.filter((g) => !g.checked);
    const hasNoActiveGarantias = garantiasAtivas.length === 0;
    const inactiveListVisible = hasNoActiveGarantias || showInactiveGarantias;

    return (
      <div className="lucia-config">
        {!canEdit && (
          <div className="lucia-config-banner">
            Somente o usuário MASTER pode alterar estas configurações.
          </div>
        )}

        {savingGarantias && (
          <div className="lucia-config-saving" aria-live="polite">
            Salvando alterações…
          </div>
        )}

        <section className="lucia-config-section">
          <h3 className="lucia-config-section-title">Produtos LucIA</h3>
          <p className="lucia-config-section-hint">
            Marque os produtos que o usuário da LucIA poderá solicitar{luciaSolicitaAtivada || produtosLucia.length > 0 ? ' (obrigatório)' : ''}:
          </p>
          {loading && <div className="lucia-config-loading">Carregando produtos…</div>}
          {!loading && (
            <div className="lucia-config-produtos-grid">
              {produtosLucia.map((product) => (
                <div key={product.id} className="lucia-config-produto-item">
                  <CheckBox
                    id={`lucia_produto_cli_${product.id}`}
                    name={`lucia_produto_cli_${product.id}`}
                    label={product.titulo}
                    checked={Boolean(product.checked)}
                    disabled={disabled}
                    onChange={() => this.toggleProdutoLucia(product.id)}
                    customstyle="width: 100%; white-space: normal;"
                  />
                </div>
              ))}
              {produtosLucia.length === 0 && (
                <p className="lucia-config-empty">Nenhum produto liberado para o usuário ADICIONAL.</p>
              )}
            </div>
          )}
        </section>

        {luciaColetaAtivada && (
          <>
            <div className="lucia-config-divider" />

            <section className="lucia-config-section">
              <h3 className="lucia-config-section-title">Coleta e Análise</h3>
              <p className="lucia-config-section-hint">
                Marque se a LucIA inicialmente irá apenas coletar os dados/documentos ou se irá processar automaticamente as Análises de Crédito ao finalizar um atendimento do LucIA COLETA:
              </p>
              <div className="lucia-config-radio-group">
                <RadioButton
                  id="coleta_e_analisa_cli_coletar"
                  label="Coletar Dados/Documentos"
                  checked={coletaEAnalisa === false}
                  disabled={disabled}
                  onChange={() => this.onColetaEAnalisaChange(false)}
                />
                <RadioButton
                  id="coleta_e_analisa_cli_coletar_analisar"
                  label={(
                    <span>
                      Coletar Dados/Documentos e Processar a Análise de Crédito
                      <span className="lucia-config-radio-hint"> (limitado a 6 pretendentes)</span>
                    </span>
                  )}
                  checked={coletaEAnalisa === true}
                  disabled={disabled}
                  onChange={() => this.onColetaEAnalisaChange(true)}
                />
              </div>
            </section>

            <div className="lucia-config-divider" />

            <section className="lucia-config-section">
              <h3 className="lucia-config-section-title">Garantias e documentos</h3>
              <p className="lucia-config-section-hint">
                Selecione as garantias e documentos que o cliente deseja disponibilizar no atendimento de coleta de documentos:
              </p>

              {loading && <div className="lucia-config-loading">Carregando garantias…</div>}
              {!loading && (
                <>
                  {hasNoActiveGarantias && garantiasInativas.length > 0 && (
                    <p className="lucia-config-empty lucia-config-empty-garantias">
                      Nenhuma garantia selecionada. Marque abaixo as que deseja disponibilizar.
                    </p>
                  )}

                  {garantiasAtivas.length > 0 && (
                    <div className="lucia-config-garantias-active">
                      {garantiasAtivas.map((g) => this.renderGarantiaBlock(g))}
                    </div>
                  )}

                  {garantiasInativas.length > 0 && (
                    <div className="lucia-config-inactive-wrap">
                      {!hasNoActiveGarantias && (
                        <button
                          type="button"
                          className="lucia-config-inactive-toggle"
                          onClick={() => this.setState({ showInactiveGarantias: !showInactiveGarantias })}
                          aria-expanded={inactiveListVisible}
                        >
                          {showInactiveGarantias ? 'Ocultar' : 'Ver'} outras garantias disponíveis ({garantiasInativas.length})
                        </button>
                      )}
                      {inactiveListVisible && (
                        <div className={`lucia-config-inactive-grid${hasNoActiveGarantias ? ' lucia-config-inactive-grid--open' : ''}`}>
                          {garantiasInativas.map((g) => this.renderInactiveGarantiaRow(g))}
                        </div>
                      )}
                    </div>
                  )}

                  {hasNoActiveGarantias && garantiasInativas.length === 0 && garantiasFc.length === 0 && (
                    <p className="lucia-config-empty">Nenhuma garantia disponível.</p>
                  )}
                </>
              )}
            </section>

            {!loading && (
              <>
                <div className="lucia-config-divider" />

                <section className="lucia-config-section lucia-config-custom-section">
                  <h3 className="lucia-config-section-title">
                    Garantias personalizadas (máx. {maxCustomizadas})
                  </h3>
                  {customizadas.map((c) => (
                    <div key={c.nome} className="lucia-config-garantia-block lucia-config-garantia-block--custom">
                      <div className="lucia-config-custom-header">
                        <strong>{c.nome}</strong>
                        {canEdit && (
                          <span
                            role="button"
                            title="Excluir"
                            onClick={() => !disabled && this.removeCustom(c.nome)}
                            className={`lucia-config-custom-delete${disabled ? ' lucia-config-custom-delete--disabled' : ''}`}
                          >
                            <CustomTrash width="1rem" color="color_red" />
                          </span>
                        )}
                      </div>
                      <div className="lucia-config-modo-row">
                        <RadioButton
                          id={`modo-custom-cli-${c.nome}-sempre`}
                          label="Sempre"
                          checked={(c.modo || 'SEMPRE') === 'SEMPRE'}
                          disabled={disabled}
                          onChange={() => this.setCustomModo(c.nome, 'SEMPRE')}
                        />
                        <RadioButton
                          id={`modo-custom-cli-${c.nome}-opcional`}
                          label="Opcional"
                          checked={c.modo === 'OPCIONAL'}
                          disabled={disabled}
                          onChange={() => this.setCustomModo(c.nome, 'OPCIONAL')}
                        />
                      </div>
                      {this.renderDocChecks(
                        c.documentos,
                        (docId) => this.toggleCustomDoc(c.nome, docId),
                        `custom-${c.nome}`
                      )}
                    </div>
                  ))}

                  {canEdit && customizadas.length < maxCustomizadas && (
                    <div className="customer-data-custom-garantia-row">
                      <label className="customer-data-custom-garantia-label" htmlFor="custom-garantia-nome">
                        Nome da garantia
                      </label>
                      <div className="customer-data-custom-garantia-actions">
                        <input
                          id="custom-garantia-nome"
                          className="customer-data-custom-garantia-input"
                          type="text"
                          maxLength={255}
                          value={customDraftNome}
                          disabled={disabled}
                          placeholder="Ex.: Parceria com seguradora X"
                          onChange={(e) =>
                            this.setState({
                              customDraftNome: e.target.value ? e.target.value.toLocaleUpperCase('pt-BR') : '',
                            })
                          }
                        />
                        <ButtonForm type="button" disabled={disabled} onClick={this.addCustom}>
                          Adicionar
                        </ButtonForm>
                      </div>
                    </div>
                  )}
                </section>
              </>
            )}
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  login: state.login,
});

export default connect(mapStateToProps)(ClientGarantias);
